import { FC, PropsWithChildren } from 'react'

import { FeatureFlagsProvider } from 'utils'
import { AbTestsProvider } from 'utils/abTests/abTests'
import { directFlowToken } from 'utils/directFlowToken'

export const CoreDirectFlowService: FC<PropsWithChildren> = ({ children }) => {
  return (
    <AbTestsProvider preQuoteKeys={{ userKey: directFlowToken, participantId: directFlowToken }}>
      <FeatureFlagsProvider preQuoteKey={directFlowToken}>{children}</FeatureFlagsProvider>
    </AbTestsProvider>
  )
}
